import TableCell from "@mui/material/TableCell";
import TableRow from "@mui/material/TableRow";
import MuiTableHead from "@mui/material/TableHead";
import Text from "@commons/Typography/Text";

type TableHeadProps = {
  heads: Array<{ id: string; label: string; className?: string }>;
  actions?: boolean;
};

function TableHead({ heads, actions }: TableHeadProps) {
  return (
    <MuiTableHead>
      <TableRow>
        {heads.map((head) => (
          <TableCell key={head.id} className="font-bold">
            <Text className={`${head.className} font-roboto font-bold`}>
              {head.label}
            </Text>
          </TableCell>
        ))}

        {actions && (
          <TableCell key="actions" className="font-bold">
            <Text className="font-roboto font-bold">Ações</Text>
          </TableCell>
        )}
      </TableRow>
    </MuiTableHead>
  );
}

export default TableHead;
